{
    "NAME": "Linguagem de banco de dados",
    "Database_Section_MaintenanceInterval_Title": "Intervalo de manutenção do banco de dados",
    "Database_Section_MaintenanceInterval_Description": "Configure um período diário durante o qual o aplicativo suspende a atividade do banco de dados. Os horários de início e término são interpretados como UTC.",
    "Database_Field_MaintenanceInterval_Enabled": "Suspender a atividade do banco de dados diariamente",
    "Database_Field_MaintenanceInterval_TimeStart": "Hora de início (UTC)",
    "Database_Field_MaintenanceInterval_TimeEnd": "Fim da Hora (UTC)",
    "Database_Field_MaintenanceInterval_DaysOfWeek": "Dias da semana",
    "Database_Day_Monday": "Segunda-feira",
    "Database_Day_Tuesday": "Terça-feira",
    "Database_Day_Wednesday": "Quarta-feira",
    "Database_Day_Thursday": "Quinta-feira",
    "Database_Day_Friday": "Sexta-feira",
    "Database_Day_Saturday": "Sábado",
    "Database_Day_Sunday": "Domingo",
    "Database_Action_Apply": "Aplicar",
    "Database_Action_Cancel": "Cancelar",
    "Database_Action_Refresh": "Atualizar",
    "Database_Save_Success": "Configurações do banco de dados salvas.",
    "Database_Save_Error": "Não foi possível salvar as configurações do banco de dados.",
    "Database_Load_Error": "Não foi possível carregar as configurações do banco de dados.",
    "Database_Warning_ReadOnly": "Você pode visualizar essas configurações, mas não tem permissão para alterá-las. Somente administradores de sistema com acesso root podem editar as configurações do banco de dados.",
    "Database_Warning_Unavailable": "As configurações do banco de dados estão indisponíveis no momento. O banco de dados pode não estar acessível quando o aplicativo foi iniciado."
}